import { handleAddToCartClick } from '../modules/single-ajax-add-to-cart';
import { initProductUrlParameterHandling } from '../modules/product-url-params';
import { initProductFormValidation, validateProductForm } from '../modules/product-form-validation';
import { initProductTabs } from '../modules/product-tabs';
import { initProductSummary } from '../modules/product-summary';
import { initProductShare } from '../modules/product-share';
import { initTrackProductView } from '../modules/visit-tracker';
import { initStickyAddToCart } from '../modules/sticky-add-to-cart-button';

// Entry point for single product page JS

document.addEventListener('DOMContentLoaded', () => {
    const elements = getElements();

    if (elements.cartForm) {
        initProductUrlParameterHandling({ cartForm: elements.cartForm });
        initProductFormValidation({
            addToCartButton: elements.addToCartButton,
            cartForm: elements.cartForm,
            requiredElements: elements.requiredElements,
            customFabricInput: elements.customFabricInput,
            fabricPicker: elements.fabricPicker,
        });

        elements.addToCartButton?.addEventListener('click', async (event) => {
            if (!validateProductForm(event, elements)) {
                // Form is invalid, do not proceed
                return;
            }
            // Form is valid, proceed with AJAX add to cart
            await handleAddToCartClick(event, elements.cartForm);
        });

        initStickyAddToCart({
            addToCartButton: elements.addToCartButton,
            cartForm: elements.cartForm,
        });
    }

    if (elements.summaryDiv) {
        initProductSummary({ summaryDiv: elements.summaryDiv });
    }

    if (elements.tabsContainer) {
        initProductTabs({ tabsContainer: elements.tabsContainer });
    }

    if (elements.copyLinkButton) {
        initProductShare({ copyLinkButton: elements.copyLinkButton });
    }

    initTrackProductView();

});

function getElements() {
    const cartForm = document.querySelector('.woocommerce div.product form.cart');
    return {
        cartForm: cartForm,
        requiredElements: cartForm ? cartForm.querySelectorAll('[required]') : [],
        addToCartButton: cartForm ? cartForm.querySelector('button.single_add_to_cart_button') : null,
        fabricPicker: cartForm ? cartForm.querySelector('#fabric-picker') : null,
        customFabricInput: cartForm ? cartForm.querySelector('#fabric-number-input') : null,
        summaryDiv: document.querySelector('.summary'),
        copyLinkButton: document.querySelector('#fgt-share-product'),
        tabsContainer: document.querySelector('.woocommerce-tabs ul.tabs'),
    };
}
